import React, { Component } from 'react';
import Game from '../containers/Game';

class App extends Component {
    render() {
        return (
            <div>
                <Game />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js